module.exports = __webpack_public_path__ + "img/background.1f88983a.jpg";